import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import Clickable, { ClickEventListener } from '@philips-emr/tws-core/lib/component/types/clickable';
import { isValidWidth } from '@philips-emr/tws-utils';

class CardAPI extends ComponentAPI implements Clickable {
  /** @event */
  @AwesomeEvent
  onClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onDoubleClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onContextMenuClick = new ClickEventListener();

  getClassName(): string {
    return this.state.className;
  }

  setClassName(className: string): void {
    this.setState({ className });
  }

  getWidth(): number {
    return this.state.width;
  }

  setWidth(width: number): void {
    if (isValidWidth(width)) {
      this.setState({ width });
    }
  }

  isTransparent(): boolean {
    return this.state.transparent;
  }

  setTransparent(transparent: boolean): void {
    this.setState({ transparent });
  }
}

export default CardAPI;
